<template>
  <div>
      <v-data-table
          dense
          :headers="getColumns"
          :items="itemList"
          item-key="id"
          class="elevation-1 text-caption grey lighten-2"
          :options="options"
          :loading="loading"
          :height="windowHeight"
          fixed-header
          :search="searchTerm"
          hide-default-footer
          show-select
          v-model="selectedItemList"
          single-select

      >
        <template v-slot:item.info="{ item}">
          <MPNResearchDetailCell :items="[
              {id: 1, name: '№', value: item.order_number},
              {id: 2, name: 'QTY', value: '2', divider: true},
              {name: 'Designator', value: 'R1, R2'}
              ]">
          </MPNResearchDetailCell>
        </template>
        <template v-slot:item.original_text="{ item}">
          <MPNResearchDetailCell :items="[{name: 'Original text', value: item.original_text}]">
          </MPNResearchDetailCell>
        </template>
        <template v-slot:item.component="{ item}">
          <MPNResearchDetailCell :items="[
              {name: 'Type', value: 'THT'},
              {name: 'Base property', value: item.mpn, divider: true},
              {name: 'Footprint', value: item.mpn},
              {name: 'Description', value: item.description},
              ]">
          </MPNResearchDetailCell>
        </template>


        <template v-slot:item.drag="{ item}">
          <div class="handle grab">
            <v-icon
                small
            >
              mdi-drag-variant
            </v-icon>
          </div>
        </template>
        <template v-slot:item.task_id="{ item }">
          <BaseTaskProgress v-model="item">
          </BaseTaskProgress>
          <v-icon
              color="primary"
              small
              @click="onNewOrDuplicate(item)"
          >
            mdi-content-duplicate
          </v-icon>
        </template>
        <template v-slot:item.qty="{ item }">
          <v-text-field
              class="mt-1 mb-n5 text-caption"
              dense
              outlined
              v-model="item.qty"
              type="number"
              :readonly="deniedEdit(item)"
              @change="onFieldChange(item, 'qty')"
          >
          </v-text-field>
        </template>
<!--        <template v-slot:item.original_text="{ item }">-->
<!--          {{ item.original_text }}-->
<!--          <span v-if="item.original_text !== null">-->
<!--          <p v-for="line in item.original_text.split('\n')" class="px-0 mx-0 text-caption">-->
<!--            <a-->
<!--                :href="'https://octopart.com/search?currency=EUR&specs=0&q=' + line"-->
<!--                target="target"-->
<!--            >-->
<!--              {{ line }}-->
<!--            </a>-->
<!--          </p>-->
<!--        </span>-->
<!--        </template>-->
        <template v-slot:item.mpn="{ item }">
          <v-textarea
              class="mt-1 mb-n5 text-caption"
              dense
              outlined
              auto-grow
              v-model="item.mpn"
              rows="1"
              :readonly="deniedEdit(item)"
              @click:append="onClickOctopart(item)"
              @click:append-outer="onClickOctopart(item)"
              @change="onFieldChange(item, 'mpn')"
          >
          </v-textarea>
        </template>
        <template v-slot:item.search_link="{ item }">
          <v-btn
              x-small
              text
              icon
              color="blue lighten-2"
              @click="onClickOctopart(item)"
          >
            <v-img height="10" contain src="/static/images/mpnresearch/octopart.svg"></v-img>
          </v-btn>
          <v-btn
              x-small
              text
              icon
              color="blue lighten-2"
              @click="onClickGoogle(item)"
          >
            <v-img height="12" contain src="/static/images/mpnresearch/google.svg"></v-img>
          </v-btn>
        </template>
        <template v-slot:item.comment="{ item }">
          <v-textarea
              class="mx-0 my-1 text-caption"
              dense
              outlined
              auto-grow
              v-model="item.comment"
              rows="3"
              clearable
              :readonly="deniedEdit(item)"
              @change="onFieldChange(item, 'comment')"
          >
          </v-textarea>
        </template>
        <template v-slot:item.partial_match="{ item }">
          <v-checkbox
              class="mt-1 mb-n3"
              v-model="item.partial_match"
              dense
              outlined
              :readonly="deniedEdit(item)"
              @change="onFieldChange(item, 'partial_match')"
          ></v-checkbox>
        </template>
        <template v-slot:item.bc_exclude_from_view="{ item }">
          <p v-for="bc in item.bc_list">
            <v-checkbox
                v-model="item.bc_exclude_from_view"
                :label="bc"
                :value="bc"
                @change="onExcludeChange(item, 'bc_exclude_from_view')"
            ></v-checkbox>
          </p>
        </template>
        <template v-for="item_batch_size in getBatchSizeList" v-slot:[`item.${item_batch_size.batch_size}`]="{item}"
                  class="ml-n4">
          <MPNResearchDetailResult :item="item" :item_batch_size="item_batch_size"></MPNResearchDetailResult>
        </template>
        <template v-slot:item.edited_on="{ item }">
          {{ item.edited_on | moment("YY.MM.DD HH:mm") }}
        </template>
        <template v-slot:top>
          <v-toolbar flat class="mt-n5">
            <v-text-field
                v-model="searchTerm"
                dense
                outlined
                label="Search"
                class="mt-5"
                clearable
                @input="onUpdateSearchTerm"
            ></v-text-field>
            <!--          <v-switch v-model="fullView" label="Any stock and price" class="ml-5 mt-4"></v-switch>-->
            <v-radio-group
                v-model="selected_view"
                row
                class="ml-5 mt-4"
                @change="onUpdateSearchTerm"
            >
              <v-radio
                  label="all results"
                  value="all"
              ></v-radio>
              <v-radio
                  label="only available"
                  value="available"
              ></v-radio>
              <v-radio
                  label="best result"
                  value="best"
              ></v-radio>
            </v-radio-group>
            <v-spacer></v-spacer>
            <MPNResearchDetailDialog
                class="ml-3"
                buttonText="Add"
                title="Add Item"
                :item="editedItem"
                :onSaveAction="onNewOrDuplicate"
            >
            </MPNResearchDetailDialog>
            <v-btn
                class="mb-2 ml-3"
                @click="onAddFromClipboard"
                :loading="addFromClipboardLoading"
            >
              Paste
            </v-btn>
          </v-toolbar>
        </template>
      </v-data-table>
      <v-toolbar flat dense>
        <v-btn
            color="primary"
            class="mr-4"
            :loading="action_loading"
            @click="onSearch"
            :disabled="!(selectedItemList.length > 0) || (getBatchSizeList.length == 0)"
        >
          Search selected
        </v-btn>
        <v-btn
            color="warning"
            class="ml-3"
            @click="onClearItems"
            :loading="clearLoading"
            :disabled="!(selectedItemList.length > 0)"
        >
          Remove selected
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" :to="{name: 'MPNResearch'}">
          Cancel
        </v-btn>
      </v-toolbar>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Sortable from 'sortablejs'
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import MPNResearchDetailDialog from "@/components/MPNResearch/MPNResearchDetailDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress";
import MPNResearchDetailResult from "@/components/MPNResearch/MPNResearchDetailResult";
import MPNResearchDetailCell from "@/components/MPNResearchV2/MPNResearchDetailCell";
import {debounce} from "debounce";

export default {
  name: 'MPNResearchDetailV2',
  props: ['bomMpnResearchId'],

  components: {
    BaseTaskProgress,
    MPNResearchDetailDialog,
    BaseDeleteDialog,
    MPNResearchDetailResult,
    MPNResearchDetailCell,
  },

  computed: {
    ...mapGetters('MPNResearchDetailV2', ['getColumns',]),
    ...mapGetters('MPNResearchBatchV2', ['getBatchSizeList']),
    ...mapFields('MPNResearchDetailV2', ['editedItem', 'itemList', 'saveLoading', 'options', 'options.rowsPerPageItems', 'options.sortBy', 'totalRecords',
      'loading', 'deleteLoading', 'copyLoading', 'clearLoading',
      'selectedItemList', 'searchLoading', 'filters', 'action_loading',
      'addFromClipboardLoading']),
  },

  methods: {
    ...mapActions('MPNResearchDetailV2',
        ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
          'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
          'fetchActionSelectedItem', 'actionAddClipboard']),

    onResize() {
      console.log('this.$route.meta.showModal', this.$route.meta.showModal)
      if (this.$route.meta.hasOwnProperty('showModal') && this.$route.meta.showModal === true)
        this.windowHeight = (window.innerHeight * 0.8 - 300)
      else
        this.windowHeight = (window.innerHeight - 300)
    },
    onSave(item) {
      console.log('onSave', item)
      if (!item)
        return
      let fields_dict = {
        mpn_research: this.bomMpnResearchId,
        id: item.id,
        task_id: null,
        task_status: null,
      }
      fields_dict = {
        ...item,
        ...fields_dict,
      }
      if (fields_dict.hasOwnProperty('values_for_batch_size'))
        delete fields_dict['values_for_batch_size']
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: fields_dict,
      })
    },
    getPurchasePrice(pn) {
      if (pn.price != pn.purchase_price && pn.purchase_price != -1 && pn.purchase_price != 0 && pn.purchase_price !== null)
        return pn.purchase_price + '€ buying ' + pn.purchase_amount + ' cnt,'
      return ''
    },
    onNewOrDuplicate(item) {
      console.log('onNewOrDuplicate' + item.id, item)
      let fields_dict = {
        mpn_research: this.bomMpnResearchId,
        id: null,
        task_id: null,
        task_status: null,
      }
      fields_dict = {
        ...item,
        ...fields_dict,
      }
      if (item.id !== null) {
        if (item.order_number !== null)
          fields_dict['order_number'] = item.order_number + 1
        let itemIdList = []
        for (let i = 0; i < this.itemList.length; i++) {
          if (this.itemList[i].order_number < item.order_number) {
            itemIdList.push(this.itemList[i].id)
          }
          if (this.itemList[i].order_number === item.order_number) {
            itemIdList.push(this.itemList[i].id)
            itemIdList.push(null)
          }
          if (this.itemList[i].order_number > item.order_number) {
            this.itemList[i].order_number++
            itemIdList.push(this.itemList[i].id)
          }
        }
        this.fetchOrderItemList(itemIdList)
      } else {
        fields_dict['order_number'] = this.itemList.length
      }
      if (fields_dict.hasOwnProperty('values_for_batch_size'))
        delete fields_dict['values_for_batch_size']
      this.fetchSaveItemField({
        itemId: null,
        fields_dict: fields_dict,
      })
    },
    onClearItems() {
      // let selectedIds = []
      // for (const item of this.selectedItemList)
      //     selectedIds.push(item.id)
      let itemIdList = []
      let index = 0
      const _self = this
      this.itemList.forEach(function (item) {
        if (!_self.selectedItemList.includes(item)) {
          item.order_number = index;
          itemIdList.push(item.id)
          index++
        }
      })
      this.fetchOrderItemList(itemIdList)
      this.fetchDeleteSelectedItem()
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.filters['selected_view'] = this.selected_view
      this.fetchItemList()
    }, 800),
    onFieldChange(item, fieldName) {
      // console.log('onFieldChange', item, fieldName)
      let fields_dict = {}
      fields_dict[fieldName] = item[fieldName]
      fields_dict['task_id'] = null
      fields_dict['task_status'] = null
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: fields_dict,
      })
    },
    onExcludeChange(item, fieldName) {
      console.log('onFieldChange', item, fieldName)
      let fields_dict = {}
      fields_dict[fieldName] = item[fieldName]
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: fields_dict,
      })
    },
    onCopyToClipboard() {
      this.actionCopyToClipboard()
    },
    onAddFromClipboard() {
      this.actionAddClipboard(this.bomMpnResearchId)
    },
    onSearch() {
      this.fetchActionSelectedItem('search_mpn')
    },
    getBackgroundColor(pn, needAmount) {
      if (pn.stock < needAmount)
        return 'stock-low'
      else
        return ''
    },
    onClickOctopart(item) {
      window.open('https://octopart.com/search?currency=EUR&specs=0&q=' + item.mpn, '_blank')
    },
    onClickGoogle(item) {
      window.open('https://www.google.com/search?newwindow=1&q=' + item.mpn, '_blank')
    },
    onEnd({newIndex, oldIndex}) {
      // console.log('onEnd', newIndex, oldIndex)
      const row = this.itemList.splice(oldIndex, 1)[0]
      this.itemList.splice(newIndex, 0, row)
      let itemIdList = []
      this.itemList.forEach(function (item, index) {
        item.order_number = index;
        itemIdList.push(item.id)
      })
      this.fetchOrderItemList(itemIdList)
    },
    deniedEdit(item) {
      return !(item.task_status === false ||
          item.task_status === true ||
          item.task_id === null)
    },
    addDaysToCurrent(days) {
      let current = new Date();
      let next = new Date();
      next.setDate(current.getDate() + days);
      return next
    },
  },

  async mounted() {
    this.filters = {mpn_research_id: this.bomMpnResearchId}
    await this.fetchItemList();
    window.addEventListener("resize", this.onResize)

    let table = document.querySelector(".v-data-table__wrapper tbody")
    Sortable.create(table, {handle: ".handle", onEnd: this.onEnd})
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      searchTerm: null,
      selected_view: 'best',
      fullView: true,
      windowHeight: (window.innerHeight - 300) + 'px',
      windowWidth: window.innerWidth + "px",
      newDialog: false,
      dialogDelete: false,
    }
  }
}
</script>

<style scoped lang="scss">
.stock-low {
  //background-color: #FFEBEE;
  color: red;
}

.lead_time {
  color: forestgreen;
}
</style>
